/** HomePage calls this when its sections have loaded, so the launch intro opens onto real content. */
export function markHomeReady(): void {
  window.__rsHomeReady = true;
  window.dispatchEvent(new Event("rs:home-ready"));
}
